
var TRANSLATIONS = TRANSLATIONS || {};

// deutsch ---------------------------
TRANSLATIONS.de = {
  MATH: {
    FRACTION: ','
  },
  OK: 'OK',
  YES: 'Ja',
  NO: 'Nein',
  TITLE: 'Olivio Konfigurator',
  PREVIOUS: 'zurück',
  NEXT: 'weiter',
  CLOSE: 'Schließen',
  RESET: 'Zurücksetzen',
  CANCEL: 'Abbrechen',
  APPLY: 'Übernehmen',
  LOGIN: 'Anmelden',
  LOGOUT: 'Abmelden',
  LOAD: 'Laden',
  WARNING: 'Warnung',
  DOWNLOAD1: 'Konfiguration abschließen und',
  DOWNLOAD2: 'Datenblatt erzeugen',
  PLEASE_ASK: 'auf Anfrage',
  STEPS: {
    PRODUCT: 'Designlinie',
    DESIGN: 'Leuchtenform',
    CHARGING: 'Ladestation',
    ASSEMBLY: 'Technik',
    DISTRIBUTION: 'Technik',
    COLOR: 'Technik',
    POWER: 'Technik',
    GOBO: 'Gobo',
    DETAILS: 'Details',
    CHECKOUT: 'Checkout'
  },
  DESIGN: {
    SIDEVIEW: 'Mast- und Lichtpunkthöhe wählen',
    TOPVIEW: 'Anzahl und Anordnung der Leuchtenköpfe um den Mast wählen',
    CHOOSE_BOOM: 'Ausleger wählen',
    CHOOSE_LUMINAIRE: 'Leuchtenkopfgröße wählen',
    NOCHOOSE_LUMINAIRE: 'Leuchtenkopfgröße',
    LUMINAIRES: 'Leuchtenköpfe',
    DESIGN: 'Design',
    MAST_TYPE: 'Mast',
    MAST_HEIGHT: 'Masthöhe',
    LUM_HEIGHT_TOP: 'Höchste Lichtpunkthöhe',
    LUM_HEIGHT_BOTTOM: 'Niedrigste Lichtpunkthöhe',
    LUM_HEIGHT: 'Lichtpunkthöhe',
    DEGREE_START: 'Startwinkel',
    DEGREE_ROTATION: 'Winkelsegment',
    DEGREE_LUM: 'Winkel Leuchtenkopf',
    LUM_NUMBER: 'Anzahl Leuchtenköpfe',
    MAST_MATERIAL: 'Mast aus',
    MAST_MATERIAL_HOLZ: 'Holz',
    MAST_MATERIAL_METALL: 'Metall',
    COLOR: 'Farbe',
    COLOR_ALL: 'Farbe Mast, Leuchtenkopf oder Inlay',
    COLOR_OUTSIDE: 'Farbe Mast oder Leuchtenkopf',
    COLOR_WOODPOLE: 'Holzsorte Mast',
    COLOR_MAST: 'Farbe Mast',
    COLOR_INLAY: 'Farbe Inlay',
    COLOR_LUM: 'Farbe Leuchtenkopf',
    BOOM_TYPE: 'Art Ausleger',
    LUM_TYPE: 'Art Leuchtenköpfe',
    COLOR_INFO: 'Bitte ziehen Sie Ihre gewünschten Farben per Drag and Drop auf die Farbboxen und klicken Sie übernehmen.',
    UNITS: 'Stück',
    DOOR: 'Tür',
    TOPVIEWBACKGROUND: 'images/design_topviewbg.svg',
    ADVANCED_LOADCONFIG: 'Konfiguration laden (SX)',
    ADVANCED_LEAVE: 'Expertenmodus verlassen',
    ADVANCED_SETTINGSLOST: 'Erweiterte Einstellung gehen verloren',
    BASE: 'Fußplatte',
    GOBO: 'Gobo auswählen',
    CHOOSE_GOBO: 'Gobo auswählen',
    GOBO_INFO_HEAD: 'Gobo',
    GOBO_INFO_STANDARD_HEAD: 'Standard-Objektiv\n(85mm)',
    GOBO_INFO_TELE_HEAD: 'Tele-Objektiv\n(150mm)',
    GOBO_INFO_WIDE_HEAD: 'Weitwinkel-Objektiv\n(63mm)',
    GOBO_INFO_EXTRAWIDE_HEAD: 'Extraweitwinkel-Objektiv\n(45mm)',
    GOBO_INFO_STANDARD_TEXT: 'Für die meisten Situationen eignet sich '+
    'die mittlere Brennweite am besten. '+
    'Das Standard-Objektiv erzeugt aus '+
    '10m Entfernung eine Projektion von ca. '+
    '4,5m Durchmesser.',
    GOBO_INFO_TELE_TEXT: 'Ein Tele-Objektiv mit großer '+
    'Brennweite bildet Projektionen kleiner '+
    'und lichtstärker ab, es ermöglicht '+
    'also eine helle Projektion über große '+
    'Distanzen. Aus 10 m Entfernung '+
    'erzeugt es eine Projektion von ca. '+
    '2,5m Durchmesser.',
    GOBO_INFO_WIDE_TEXT: 'Ein Weitwinkel-Objektiv vergrößert das '+
    'Motiv. Dabei wird die Lichtmenge auf '+
    'eine größere Fläche verteilt und die '+
    'Projektion erscheint dunkler. Aus 10m '+
    'Entfernung erzeugt es eine Projektion '+
    'von ca. 6,5m Durchmesser.',
    GOBO_INFO_EXTRAWIDE_TEXT: 'Ein solches Objektiv ermöglicht '+
    'eine extragroße Brennweite '+
    'besonders geringe Abstände zur'+
    'Projektionsfläche. Es erzeugt aus 10m '+
    'Entfernung eine Projektion von ca. '+
    '8,75m Durchmesser.',
    GOBO_INFO_LOOKBOOK: 'Lookbook',
    GOBO_INFO_LOOKBOOK_URL: 'https://www.selux.com/lookbook/olivio-gobo_ger/',
    CHARGING_NUMBER: 'Anzahl Ladestationen',
    CHARGING_TYPE: 'Modell',
    CHARGING_POWER: 'Ladeleistung',
    ANCHOR: 'Erdstück',
    ANCHOR_WO: 'ohne',
    ANCHOR_WITH: 'mit'
  },
  CHARGING: {
    QUESTION: 'Ladestation hinzufügen?',
    TOPVIEW: 'Anzahl und Anordnung der Ladestationen um den Mast wählen',
    CHOOSE_TYPE: 'Modell wählen',
    CHOOSE_POWER: 'kW wählen',
    charging: 'Ladestation',
    chargings: 'Ladestationen',
    CHARGING_BASIC: 'Basic',
    CHARGING_ADV: 'Advanced',
    CHARGING_PROF: 'Professional',
    CHECKOUT: 'Ladestationen'
  },
  ASSEMBLY: {
    TITEL: 'Leuchtmittel',
    LED: 'LED',
    LED_DESCRIPTION: '',
    HIT: 'HIT',
    HIT_DESCRIPTION: '',
    CPO: 'CPO',
    CPO_DESCRIPTION: '',
  },
  DISTRIBUTION: {
    TITEL: 'Lichtverteilung',
    ASYMETRIC: 'Asymmetrisch',
    SPOT: 'Spot',
    MEDIUM: 'Medium',
    FLOOD: 'Flood',
    TYP2: 'Typ II',
    TYP5: 'Typ V'
  },
  GOBO: {
    TITEL: "Grande Gobo LED, Ø 205 Lichtfarbe 6500K, Leistung 49W",
    EXTRAWIDE: 'Extraweit',
    WIDE: 'Weitwinkel',
    STANDARD: 'Standard',
    TELE: 'Tele'
  },
  COLOR: {
    TITEL: 'Lichtfarbe',
    COL2700K: '2700K',
    COL2700K_DESCRIPTION: '',
    COL3000K: '3000K',
    COL3000K_DESCRIPTION: 'warmweiß',
    COL4000K: '4000K',
    COL4000K_DESCRIPTION: 'neutralweiß',
    COL4200K: '4200K',
    COL4200K_DESCRIPTION: '',
    COL5300K: '5300K',
    COL5300K_DESCRIPTION: '',
    RGBW: 'RGBW',
    RGBW_DESCRIPTION: 'mehrfarbig',
    MONOCHROME: 'einfarbig',
    MONOCHROME_DESCRIPTION: '',
    INFO: 'Die Lichtfarbe kann nur bei LED-Bestückung gewählt werden.',
    BACK: 'Bestückung ändern',
    SKIP: 'Überspringen',
  },
  POWER: {
    TITEL: 'Leistung',
  },
  CHECKOUT: {
    SURCHARGE: 'Aufpreis für Farbe',
    OPENINBROWSSER: 'Diese Konfiguration im Browser aufrufen',
    SPECSHEET: 'Datenblatt',
    PRINT: 'drucken',
    DOWNLOAD_PDF: 'PDF',
    DOWNLOAD_DXF_SIDE: 'DXF Seite',
    DOWNLOAD_DXF_TOP: 'DXF Oben',
    DOWNLOAD_DXF_ZIP: 'DXF',
    DOWNLOAD_LDT_ZIP: 'LDT',
    CUSTOMIZE: 'personalisieren',
    MANUAL: 'Montage',
    CONFIGURATION: 'Leuchtenkonfiguration',
    CONFIGNUMBER: 'Konfigurationsnummer',
    ARRANGMENT: 'Anordnung',
    SINGLELEVEL: 'Auf einer Ebene',
    STAGGERDLEVEL: 'Auf unterschiedlichen Ebenen',
    SEEPAGETWO: 'Details siehe Seite 2',
    CONTACTINTRO: 'Für weitere Details oder individuelle Konfigurationen können Sie gerne Kontakt mit uns aufnehmen.',
    REQUESTQUOTE: 'Persönliches Angebot anfordern',
    INFOLINE1: 'Aufgrund der stetigen Weiterentwicklung und Verbesserung der LED-Technologie sind Änderungen möglich.',
    INFOLINE2: '© Selux GmbH, Technische Änderungen vorbehalten 03.2014',
    CONTACTLINE1: 'Selux GmbH, Volkmarstr. 18, D-12099 Berlin, T +49 30 72001-0, F -100',
    LUMINAIRE: 'Leuchtenkopf',
    BRACKET: 'Ausleger',
    POLE: 'Mast',
    WOODPOLE: 'Holzmast',
    HEIGHT: 'Höhe',
    DIAMETER: 'Durchmesser',
    DEGREE_ROTATION: 'Winkel',
    LAMP: 'Leuchtm.',
    COLOR: 'Lichtfarbe',
    POWER: 'Leistung',
    DISTRIBUTION: 'Verteilung',
    DRILLINTRO: 'Leuchtenanschluss von Mastpitze ausgehend',
    DRILLINTROFLORACION: 'Leuchtenanschluss von Mastunterkante (ohne Fußplatte)',
    HOLENUM: 'Anschlusspunkt',
    HOLELUMHEIGHT: 'Lichtpunkthöhe',
    HOLEHEIGHT: 'Anschlussbohrung',
    HOLEANGLE: 'Drehung',
    COMPANY: 'Firma',
    CONTACT: 'Kontaktperson',
    PHONE: 'Telefon',
    EMAIL: 'E-Mail-Adresse',
    PROJECTNAMEID: 'Projekt-Name/Nummer',
    PROJECTNAME: 'Projekt-Name',
    PROJECTID: 'Nummer',
    PROJECTADDRESS: 'Projekt-Adresse',
    PROJECTNOTE: 'Projekt-Bemerkung',
    MESSAGE: 'Ihre Nachricht',
    STREET: 'Straße',
    NR: 'Nr.',
    CITY: 'Ort',
    ZIP: 'PLZ' ,
    COUNTRY: 'Staat',
    SEND: 'Absenden',
    CLOSE: 'Schließen',
    SENDING: 'Sende Anfrage ...',
    SENDINGSUCCESS: 'Anfrage gesendet!',
    SENDINGERROR: 'Fehler beim Senden der Anfrage!',
    ARTICLENUMBER: 'Artikelnummer',
    PRICE: 'Preis',
    PIECES: 'Stück',
    SUM: "gesamt",
    DISPLAYPRICES: "Preise anzeigen",
    DISPLAYNUMBERS: "Artikelnummern anzeigen",
    DISPLAYDRILLHOLES: "Bohrlochvermaßung anzeigen",
    CONFIRMATIONHEAD: "Mit der Bitte um Gegenbestätigung/Freigabe",
    CONFIRMATIONSIGNATURE: "Stempel/Datum/Unterschrift",
    GOBO_LENS: 'Objektiv',
    ANCHOR: 'Erdstück'
  },
  PRICE: {
    SUBTOTAL: 'Brutto Zwischensumme',
    PIECES: 'Stück'
  },
  COLORS: {
    SELUXGRAPHITE: 'Selux Graphit',
    RAL9005: 'Tiefschwarz',
    RAL7016: 'Anthrazitgrau',
    RAL7024: 'Graphitgrau',
    RAL7011: 'Eisengrau',
    RAL9007: 'Graualuminium',
    RAL9006: 'Weißaluminium',
    RAL9010: 'Reinweiß',
    RAL9016: 'Verkehrsweiß',
    RAL6009: 'Tannengrün',
    RAL6005: 'Moosgrün',
    RAL5003: 'Saphirblau',
    RAL3005: 'Weinrot',
    RAL3003: 'Rubinrot',
    DB703: 'Dunkelgrau Perl',
    DB702: 'Silbergrau Perl',
    DB701: 'Weißaluminium Perl',

    LIVERPOOL: 'Liverpool',
    SANSSOUCI: 'Sanssouci',
    VERSAILLE: 'Versaille',
    BLACKMATT: 'Mattschwarz',

    WOOD_REDWOOD: 'Red Wood',
    WOOD_CANADIANBROWN: 'Canadian Brown',
    WOOD_COOLSCANDINAVIAN: 'Cool Scandinavian',
    WOOD_TENERIFFAGREY: 'Teneriffa Grey',
    WOOD_ROCKYMOUNTAINGREY: 'Rocky Mountain Grey',
    WOOD_HIMALAYAGREY: 'Himalaya Grey',
  },

  EOF: 'EOF'
};


console.log('added de to TRANSLATIONS', TRANSLATIONS);
